import { ContactUsConfig } from '@tenants/types';
import { LOCALE_EXP_COMMERCIAL_CA_PATHS } from 'types/locales';

export const contactUsConfig: ContactUsConfig = {
  title: LOCALE_EXP_COMMERCIAL_CA_PATHS.CONTACT_TITLE,
  description: LOCALE_EXP_COMMERCIAL_CA_PATHS.CONTACT_DESCRIPTION,
  notificationContent: LOCALE_EXP_COMMERCIAL_CA_PATHS.CONTACT_NOTIFICATIONCONTENT,
  bottomContent: {
    title: LOCALE_EXP_COMMERCIAL_CA_PATHS.CONTACT_BOTTOMCONTENT_TITLE,
    description: LOCALE_EXP_COMMERCIAL_CA_PATHS.CONTACT_BOTTOMCONTENT_DESCRIPTION,
  },
  hubspotFormId: '98b5488a-62d2-41d9-b145-a03b807068bd',
};
